"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _ReferenceResolversContext = _interopRequireDefault(require("./ReferenceResolversContext"));

var _default = function _default(Component) {
  var ComponentWithContext = function ComponentWithContext(props) {
    return _react.default.createElement(_ReferenceResolversContext.default.Consumer, null, function (context) {
      return _react.default.createElement(Component, (0, _extends2.default)({}, props, {
        referenceResolverContext: context
      }));
    });
  };

  return ComponentWithContext;
};

exports.default = _default;
module.exports = exports.default;